import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocAlertIssueSyncingRoute } from '@jira/router-routes__eoc-alert-issue-syncing-routes/src/eocAlertIssueSyncingRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { resources as alertIssueSyncingResources } from '@atlassian/eoc-alert-issue-syncing/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';
import { LazyAlertIssueSync } from './ui/async.tsx';
import { AlertIssueSync } from './ui/AlertIssueSync.tsx';

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const eocAlertIssueSyncingRouteEntry: Route = createEntry(eocAlertIssueSyncingRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: AlertIssueSync,
	slot: null,
	basePath: '/jira/settings/products/ops',
	layout: opsSettingsLayout,

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	resources: [
		...getNavigationResources(),
		...getNavigationSidebarProductsSettingResource(),
		alertIssueSyncingResources.configuredSyncsResource,
		alertIssueSyncingResources.userAccessRightsResource,
	] as RouteResources,

	navigation: {
		menuId: MenuIdSettings,
		...getNavigationSpecifications(),
	},

	forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyAlertIssueSync],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
